// import { createSlice } from "@reduxjs/toolkit";

// // Check for existing user in sessionStorage when the app loads
// const initialState = {
//   loading: false,
//   user: sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) : null,
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     setLoading: (state, action) => {
//       state.loading = action.payload;
//     },
//     setUser: (state, action) => {
//       state.user = action.payload;
//       // Persist the user data in sessionStorage
//       if (action.payload) {
//         sessionStorage.setItem("user", JSON.stringify(action.payload));
//       } else {
//         sessionStorage.removeItem("user"); // Remove user data on logout
//       }
//     },
//   },
// });

// export const { setLoading, setUser } = authSlice.actions;
// export default authSlice.reducer;
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { setLoading, setUser } = authSlice.actions;
export default authSlice.reducer;